import { priceBookIdFormat } from "@redotech/redo-marketplace-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getPriceBookAccounts = unaryRpc({
  name: "getPriceBookAccounts" as const,
  input: z.object({ priceBookId: priceBookIdFormat.schema }),
  output: z.object({ teamIds: z.array(z.string()) }),
});
